let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kt5YM")).then(() => parcelRequire('5nAqP'));